module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_data04-sp-954c88eab3d12d1e2ee72bcbea53a1f9.png";